import { createSlice } from '@reduxjs/toolkit'
import {
  fetchUserWaterTestKitRequestsAsync,
  fetchUserWaterTestKitRequestsBuilder,
  fetchWaterTestKitRequestsAsync,
  fetchWaterTestKitRequestsBuilder,
  updateWaterTestKitRequestAsync,
} from './asyncRequests'

export interface WaterTestKitRequest {
  _id: string
  name: string
  email: string
  address: {
    address1: string
    address2: string
    city: string
    state: string
    country: string
    zip: string,
    coordinates?: {
      formatted_address: string,
      latitude: number,
      longitude: number,
    }
  }
  utility: string
  waterSourceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  equipment?: string[]
  systems: string[]
  home_age: string
  refrigerator_brand: string
  refrigerator_model: string
}

export interface WaterTestKitRequestsInitialState {
  data: Partial<WaterTestKitRequest>[]
  loading: boolean
  error: boolean
}

const initialState: WaterTestKitRequestsInitialState = {
  data: [],
  loading: false,
  error: false,
}

const waterTestKitRequestsSlice = createSlice({
  name: 'waterTestKits',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    fetchWaterTestKitRequestsBuilder(builder)
    fetchUserWaterTestKitRequestsBuilder(builder)

  },
})

export const WaterTestKitsActions = {
  ...waterTestKitRequestsSlice.actions,
  fetchWaterTestKitRequestsAsync,
  fetchUserWaterTestKitRequestsAsync,
  updateWaterTestKitRequestAsync

}

export const WaterTestKitsReducer = waterTestKitRequestsSlice.reducer
